import { createFileRoute } from "@tanstack/react-router";
import LegalPage from "@/components/LegalPage";

export const Route = createFileRoute("/_default/privacy")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <LegalPage titleKey="legal_privacy_title" bodyKey="legal_privacy_body" />
  );
}
